import { render } from "./TransferScreenApp.vue?vue&type=template&id=266a76f4"
import script from "./TransferScreenApp.vue?vue&type=script&lang=js"
export * from "./TransferScreenApp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__